const providersSelected = user => !['NEW', 'CONFIGURATION_COMPLETE'].includes(user?.status) 
    || (user?.providers?.length && !user?.providers?.every(provider => provider?.status === 'NEW'));

export const signupInProgress = user => !user || !user?.emailVerified || !providersSelected(user);
